import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import NavbarComp1 from "../components/Navbar1";
import { UserContext } from "../jsx/UserContext";
import api from "../jsx/axiosClient";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Footer from "../components/Footer";
import isllivetranscriptImg from "../images/live-transcript.png";
import islCDACImg from "../images/cdac_ideal.mp4";
import loadingImg from "../images/loading.gif";

import { FaRedo } from "react-icons/fa";
const ISLVideoPage = () => {
  const { id } = useParams();
  const { userSession } = useContext(UserContext);
  const MySwal = withReactContent(Swal);
  const [model, setModel] = useState("m2");
  const [signModelChoices, setSignModelChoices] = useState([]);
  const selectedModelObj = signModelChoices.find(item => item.key === model);
  console.log("selectedModelObj", selectedModelObj)
  console.log("DB VALUE:", selectedModelObj?.db_value);
  const [isRedescribing, setIsRedescribing] = useState(false);
  const [isModelLoading, setIsModelLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [video, setVideo] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [progressBar, setProgressBar] = useState(0);
  const [timeText, setTimeText] = useState("0:00 / 0:00");
  const [currentIslUrl, setCurrentIslUrl] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [selectedModel, setSelectedModel] = useState("avatar-male-1");
  const videoRef = useRef(null);
  const [uniqueid, setUniqueId] = useState(null);
  const [islredescribedetails, setRedescribed_details] = useState(null);

  const styles = {
    maroonBtn: {
      backgroundColor: '#800000',
      color: '#fff',
      border: 'none',
      padding: '8px 16px',
      fontSize: '1rem',
      borderRadius: '4px',
      whiteSpace: 'nowrap'
    },
    maroonBtnDisabled: {
      backgroundColor: '#a5a5a5',
      color: '#fff',
      border: 'none',
      padding: '8px 16px',
      fontSize: '1rem',
      borderRadius: '4px',
      cursor: 'not-allowed',
      whiteSpace: 'nowrap'
    }
  };
  const uploadedVideoRef = useRef(null);
  const islVideoRef = useRef(null);
  const progressRailRef = useRef(null); // Reference to track clicks

  const timeToSeconds = (timeStr) => {
    if (!timeStr) return 0;
    const parts = timeStr.split(':').map(parseFloat);
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    return parts[0] * 60 + parts[1];
  };

  const formatTime = (s) => {
    if (!s || isNaN(s)) return "0:00";
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  // Function to handle scrubbing/moving the progress bar
  const handleProgressClick = (e) => {
    const rail = progressRailRef.current;
    const vid = uploadedVideoRef.current;
    if (!rail || !vid || !vid.duration) return;

    const rect = rail.getBoundingClientRect();
    const pos = (e.clientX - rect.left) / rect.width;
    const newTime = pos * vid.duration;

    vid.currentTime = newTime;
    setProgressBar(pos * 100);
  };

  useEffect(() => {
    const fetchVideoDetails = async () => {
      if (!userSession?.access_token) return;
      try {
        const response = await api.get(`/file/${id}`, {
          headers: { Authorization: `Bearer ${userSession.access_token}` },
        });

        const result = response.data;
        console.log("Video details:", result);
        setRedescribed_details(result);
        if (result.status === "success") {
          const fileData = result.data.file;
          const formData = result.data.form_data;
          console.log("unique_id", result.data.unique_id)
          const islTranslation = fileData.isl_url[0].isltranslation;
          console.log("islTranslation", islTranslation);

          setVideo({
            ...fileData,
            output_download_url: fileData.output_download_url
              ? (fileData.output_download_url.startsWith("http")
                ? fileData.output_download_url
                : `https://ccvai.chalachitravaachana.org/${fileData.output_download_url}`)
              : (fileData.video_url?.startsWith("http")
                ? fileData.video_url
                : `https://ccvai.chalachitravaachana.org/${fileData.video_url}`),
          });
          setModel(formData.selected_model_key || "m2");
          setSignModelChoices(formData.sign_model_choices || []);
          setIsModelLoading(false);
          setUniqueId(result.data.unique_id);
        } else {

          Swal.fire({
            icon: "error",
            text: "Failed to fetch video details.",
          });
        }
      } catch (error) {
        console.error("Error fetching video details:", error);
        Swal.fire({
          icon: "error",
          text: "Server error: Could not fetch video detail.",
        });
      }
    };

    fetchVideoDetails();
  }, [id, userSession]);
  const onTimeUpdate = () => {
    const mainVid = uploadedVideoRef.current;
    if (!mainVid || !mainVid.duration) return;
    const currentTime = mainVid.currentTime;
    setProgressBar((currentTime / mainVid.duration) * 100);
    setTimeText(`${formatTime(currentTime)} / ${formatTime(mainVid.duration)}`);
    //starttime and end time matches code
    if (video?.isl_url) {
      const activeSegment = video.isl_url.find(seg => {
        const start = timeToSeconds(seg.start_time);
        const end = timeToSeconds(seg.end_time);
        return currentTime >= start && currentTime <= end;
      });
      if (activeSegment) {
        const formattedUrl = activeSegment.isltranslation.replace(".json_", "_");
        const fullUrl = formattedUrl.startsWith('http') ? formattedUrl : `https://ccvai.chalachitravaachana.org${formattedUrl}`;
        if (currentIslUrl !== fullUrl) {
          setCurrentIslUrl(fullUrl);
          setCurrentText(activeSegment.text);
        }
      } else {
        setCurrentIslUrl("");
        setCurrentText("");
      }
    }


  };

  useEffect(() => {
    if (isPlaying) { islVideoRef.current?.play().catch(() => { }); }
    else { islVideoRef.current?.pause(); }
  }, [currentIslUrl, isPlaying]);

  const togglePlay = () => {
    const vid = uploadedVideoRef.current;
    if (!vid) return;
    vid.paused ? vid.play() : vid.pause();
    setIsPlaying(!vid.paused);
  };

  const toggleMute = () => {
    if (uploadedVideoRef.current) {
      uploadedVideoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleRedescribe = async () => {
    if (!userSession?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Please log in again.",
      });
      return;
    }
    setIsRedescribing(true);
    setProgress(0);
    try {
      const requestData = {
        video_id: id,
        model,
      };

      console.log("Redescribe request:", requestData);
      const ws = new WebSocket(`wss://ccvai.chalachitravaachana.org/ws/${uniqueid}/${id}`);
      ws.onopen = () => {
        console.log("WebSocket connected");
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("WebSocket message:", data);

          if (data.progress_percent) {
            setProgress(data.progress_percent);
          }
          if (data.progress_percent == "100" && data.video_url) {
            const updatedVideoUrl = data.video_url.startsWith("http")
              ? data.video_url
              : `https://ccvai.chalachitravaachana.org/${data.video_url}`;

            MySwal.fire({
              icon: "success",
              title: "Video Updated!",
              text: "Redescription successful. Your new video is ready.",
              showConfirmButton: false,
              timer: 2500,
            });

            setVideo((prev) => ({
              ...prev,
              video_url: updatedVideoUrl,
            }));

            setIsRedescribing(false);
            setProgress(100);
            ws.close();

            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.load();
                videoRef.current.play().catch((e) => console.warn("Autoplay blocked:", e));
              }
            }, 800);
          }
        } catch (err) {
          console.error("WebSocket message error:", err);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        Swal.fire({
          icon: "error",
          title: "Connection Error",
          text: "WebSocket connection failed.",
        });
        setIsRedescribing(false);
      };

      ws.onclose = () => console.log("WebSocket closed");
      console.log("requestData", requestData)
      const response = await api.post("https://ccvai.chalachitravaachana.org/redescribe-isl-file", requestData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`
        },
        withCredentials: true,
      });

      console.log("Redescribe response:", response.data);
      if (response.data.status !== "success") {
        Swal.fire({
          icon: "warning",
          title: "Failed",
          text: response.data.message || "Could not redescribe video.",
        });
        setIsRedescribing(false);
        ws.close();
      }
    } catch (error) {
      console.error("Error redescribing video:", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Could not redescribe video.",
      });
      setIsRedescribing(false);
    }
  };



  return (
    <div className="isl-app-wrapper">
      <style>{`
        html, body { height: 100%; margin: 0; overflow: hidden; background: #ffffff; }
        .isl-app-wrapper {
        //  background: #ffffff; 
            background: #E5E7EB;
         height: 100vh; 
         display: flex; 
         flex-direction: column; 
         color: #333; }
        .workspace { flex: 1; display: flex; flex-direction: column; padding: 15px; overflow: hidden; }
        .video-layout { display: flex; flex: 1; gap: 15px; min-height: 0; }
        .card-container { 
        background:black;
        border: 1px solid #e0e0e0; 
        border-radius: 8px; display: flex; 
        flex-direction: column; overflow: hidden;
         box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
        .main-video-area { flex: 2; }
        .side-avatar-area { flex: 1; }
        .video-header { background: #fdfdfd; padding: 12px 16px; font-size: 1.1rem; color: #222; border-bottom: 1px solid #eee; font-weight: 700; display: flex; align-items: center; }
        .media-box { 
        position: relative; flex: 1; display: flex; align-items: center; justify-content: center; overflow: hidden; }
        video { max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; cursor: pointer; }
        .controls-overlay { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.65); padding: 8px 15px; display: flex; align-items: center; gap: 12px; z-index: 10; }
        .icon-btn { background: none; border: none; color: #fff; font-size: 1.3rem; cursor: pointer; padding: 0; display: flex; align-items: center; }
        
        /* Interactive Progress Rail */
        .progress-rail { flex: 1; height: 8px; background: rgba(255,255,255,0.3); border-radius: 4px; cursor: pointer; position: relative; transition: height 0.1s; }
        .progress-rail:hover { height: 10px; }
        .progress-fill { height: 100%; background: #B01047; border-radius: 4px; pointer-events: none; }
        
.custom-maroon-btn {
  background-color: #B01047 !important;
  border: none !important;
  color: #fff !important;
}

.custom-maroon-btn:hover {
  background-color: #8c0d3a !important;
}

        .timestamp { font-family: monospace; font-size: 0.8rem; color: #fff; min-width: 90px; }
       /* .action-bar { height: 60px; background: #ffffff; border-top: 1px solid #eee; padding: 0 20px; display: flex; align-items: center; justify-content: space-between; }*/
       .action-bar { 
          min-height: 70px; 
          // background: #ffffff; 
              background: #E5E7EB;
          border-top: 1px solid #eee; 
          padding: 10px 20px; 
          display: flex; 
          align-items: center; 
        }
       
       @media (max-width: 576px) {
          .workspace { overflow-y: auto; flex: none; height: auto; }
          .video-layout { flex: none; }
          .card-container { height: 350px; }
          .action-bar { height: auto; padding: 15px; }
          .action-bar .d-flex { flex-direction: column; align-items: flex-start !important; width: 100%; }
          .model-select { width: 100%; }
          .action-bar button { width: 100%; justify-content: center; }
          html, body { overflow: auto; }
          .isl-app-wrapper { height: auto; min-height: 100vh; }
        }
       .model-select { background: #fff; color: #333; border: 1px solid #ddd; padding: 5px 10px; border-radius: 5px; font-size: 0.8rem; width: 200px; outline: none; }
        @media (max-width: 991px) {
          .video-layout { flex-direction: column; overflow-y: auto; }
          .card-container { flex: none; height: 40vh; margin-bottom: 10px; }
          html, body { overflow: auto; }
          .isl-app-wrapper { height: auto; }
        }
      `}</style>

      <NavbarComp1 />

      <div className="workspace">
        <div className="video-layout">
          <div className="card-container main-video-area">
            <div className="video-header">
              <i className="bi bi-play-fill me-1" style={{ color: '#B01047' }}></i>
              {video?.name || "Original Video"}
            </div>

            <div className="media-box">
              <video
                ref={uploadedVideoRef}
                src={video?.video_url ? `https://ccvai.chalachitravaachana.org${video.video_url}` : ""}
                onTimeUpdate={onTimeUpdate}
                onClick={togglePlay}
                playsInline
              />
              <div className="controls-overlay">
                <button className="icon-btn" onClick={togglePlay}>
                  {isPlaying ? <i className="bi bi-pause-fill"></i> : <i className="bi bi-play-fill"></i>}
                </button>
                <div className="timestamp">{timeText}</div>

                <div
                  className="progress-rail"
                  ref={progressRailRef}
                  onClick={handleProgressClick}
                >
                  <div className="progress-fill" style={{ width: `${progressBar}%` }}></div>
                </div>

                <button className="icon-btn" onClick={toggleMute}>
                  {isMuted ? <i className="bi bi-volume-mute-fill"></i> : <i className="bi bi-volume-up-fill"></i>}
                </button>
              </div>
            </div>
          </div>


          {/* Avatar Section */}
          <div className="card-container side-avatar-area">
            <div className="video-header">
              <i className="bi bi-play-fill me-1" style={{ color: '#B01047' }}></i> ISL Translator
            </div>
            <div className="media-box" style={{ backgroundColor: 'white' }}>
              {currentIslUrl ? (
                <>

                  <video
                    key={currentIslUrl}
                    ref={islVideoRef}
                    src={currentIslUrl}
                    autoPlay
                    muted
                    loop

                  />


                  <div style={{
                    position: 'absolute',
                    bottom: '0',
                    width: '100%',
                    minHeight: '70px',
                    padding: '12px 16px',
                    background: 'rgb(255 255 255 / 25%)',

                    color: '#8c0d3a',

                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                  }}>
                    {currentText}
                  </div>
                </>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center">

                  {isModelLoading ? (
                    <img
                      src={loadingImg}
                      alt="Loading"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                      }}
                    />
                  ) : selectedModelObj?.db_value === "amrita_m1" ? (
                    <img
                      src={isllivetranscriptImg}
                      alt="Amrita Avatar"
                      style={{
                        maxWidth: "80%",
                        height: "auto",
                        marginBottom: "10px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <video
                      src={islCDACImg}
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        maxWidth: "90%",
                        height: "auto",
                        marginBottom: "10px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>

              )}
            </div>
          </div>
        </div>
      </div>


      <div className="action-bar">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <div className="d-flex align-items-center gap-2">
            <span
              className="fw-bold"
              style={{ fontSize: '1rem', color: 'black', whiteSpace: 'nowrap' }}
            >
              NARRATOR:
            </span>

            <select
              className="model-select"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              style={{ fontSize: '1rem', padding: '6px 12px' }}
            >
              {signModelChoices.map((item) => (
                <option key={item.key} value={item.key}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <Button
            style={{ ...( isRedescribing ? styles.maroonBtnDisabled : styles.maroonBtn), display: "none" }}
            onClick={handleRedescribe}
            disabled={isRedescribing}
            className="align-items-center custom-maroon-btn "
          >
            {isRedescribing ? (
              `Processing ${progress}%`
            ) : (
              <>
                Regenerate ISL

              </>
            )}
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ISLVideoPage;


// import React, { useState, useEffect, useContext, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import NavbarComp1 from "../components/Navbar1";
// import { UserContext } from "../jsx/UserContext";
// import api from "../jsx/axiosClient";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Footer from "../components/Footer";
// import isllivetranscriptImg from "../images/live-transcript.png";
// import islCDACImg from "../images/cdac_ideal.mp4";
// import loadingImg from "../images/loading.gif";

// import { FaRedo } from "react-icons/fa";
// const ISLVideoPage = () => {
//   const { id } = useParams();
//   const { userSession } = useContext(UserContext);
//   const MySwal = withReactContent(Swal);
//   const [model, setModel] = useState("m2");
//   const [signModelChoices, setSignModelChoices] = useState([]);
//   const selectedModelObj = signModelChoices.find(item => item.key === model);
//   console.log("selectedModelObj", selectedModelObj)
//   console.log("DB VALUE:", selectedModelObj?.db_value);
//   const [isRedescribing, setIsRedescribing] = useState(false);
//   const [isModelLoading, setIsModelLoading] = useState(true);
//   const [progress, setProgress] = useState(0);
//   const [video, setVideo] = useState(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isMuted, setIsMuted] = useState(false);
//   const [progressBar, setProgressBar] = useState(0);
//   const [timeText, setTimeText] = useState("0:00 / 0:00");
//   const [currentIslUrl, setCurrentIslUrl] = useState("");
//   const [currentText, setCurrentText] = useState("");
//   const [selectedModel, setSelectedModel] = useState("avatar-male-1");
//   const videoRef = useRef(null);
//   const [uniqueid, setUniqueId] = useState(null);
//   const [islredescribedetails, setRedescribed_details] = useState(null);

//   const styles = {
//     maroonBtn: {
//       backgroundColor: '#800000',
//       color: '#fff',
//       border: 'none',
//       padding: '8px 16px',
//       fontSize: '1rem',
//       borderRadius: '4px',
//       whiteSpace: 'nowrap'
//     },
//     maroonBtnDisabled: {
//       backgroundColor: '#a5a5a5',
//       color: '#fff',
//       border: 'none',
//       padding: '8px 16px',
//       fontSize: '1rem',
//       borderRadius: '4px',
//       cursor: 'not-allowed',
//       whiteSpace: 'nowrap'
//     }
//   };
//   const uploadedVideoRef = useRef(null);
//   const islVideoRef = useRef(null);
//   const progressRailRef = useRef(null); // Reference to track clicks

//   const timeToSeconds = (timeStr) => {
//     if (!timeStr) return 0;
//     const parts = timeStr.split(':').map(parseFloat);
//     if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
//     return parts[0] * 60 + parts[1];
//   };

//   const formatTime = (s) => {
//     if (!s || isNaN(s)) return "0:00";
//     const m = Math.floor(s / 60);
//     const sec = Math.floor(s % 60);
//     return `${m}:${sec.toString().padStart(2, "0")}`;
//   };

//   // Function to handle scrubbing/moving the progress bar
//   const handleProgressClick = (e) => {
//     const rail = progressRailRef.current;
//     const vid = uploadedVideoRef.current;
//     if (!rail || !vid || !vid.duration) return;

//     const rect = rail.getBoundingClientRect();
//     const pos = (e.clientX - rect.left) / rect.width;
//     const newTime = pos * vid.duration;

//     vid.currentTime = newTime;
//     setProgressBar(pos * 100);
//   };

//   useEffect(() => {
//     const fetchVideoDetails = async () => {
//       if (!userSession?.access_token) return;
//       try {
//         const response = await api.get(`/file/${id}`, {
//           headers: { Authorization: `Bearer ${userSession.access_token}` },
//         });

//         const result = response.data;
//         console.log("Video details:", result);
//         setRedescribed_details(result);
//         if (result.status === "success") {
//           const fileData = result.data.file;
//           const formData = result.data.form_data;
//           console.log("unique_id", result.data.unique_id)
//           const islTranslation = fileData.isl_url[0].isltranslation;
//           console.log("islTranslation", islTranslation);

//           setVideo({
//             ...fileData,
//             output_download_url: fileData.output_download_url
//               ? (fileData.output_download_url.startsWith("http")
//                 ? fileData.output_download_url
//                 : `https://ccvai.chalachitravaachana.org/${fileData.output_download_url}`)
//               : (fileData.video_url?.startsWith("http")
//                 ? fileData.video_url
//                 : `https://ccvai.chalachitravaachana.org/${fileData.video_url}`),
//           });
//           setModel(formData.selected_model_key || "m2");
//           setSignModelChoices(formData.sign_model_choices || []);
//           setIsModelLoading(false);
//           setUniqueId(result.data.unique_id);
//         } else {

//           Swal.fire({
//             icon: "error",
//             text: "Failed to fetch video details.",
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching video details:", error);
//         Swal.fire({
//           icon: "error",
//           text: "Server error: Could not fetch video detail.",
//         });
//       }
//     };

//     fetchVideoDetails();
//   }, [id, userSession]);
//   const onTimeUpdate = () => {
//     const mainVid = uploadedVideoRef.current;
//     if (!mainVid || !mainVid.duration) return;
//     const currentTime = mainVid.currentTime;
//     setProgressBar((currentTime / mainVid.duration) * 100);
//     setTimeText(`${formatTime(currentTime)} / ${formatTime(mainVid.duration)}`);
//     //starttime and end time matches code
//     if (video?.isl_url) {
//       const activeSegment = video.isl_url.find(seg => {
//         const start = timeToSeconds(seg.start_time);
//         const end = timeToSeconds(seg.end_time);
//         return currentTime >= start && currentTime <= end;
//       });
//       if (activeSegment) {
//         const formattedUrl = activeSegment.isltranslation.replace(".json_", "_");
//         const fullUrl = formattedUrl.startsWith('http') ? formattedUrl : `https://ccvai.chalachitravaachana.org${formattedUrl}`;
//         if (currentIslUrl !== fullUrl) {
//           setCurrentIslUrl(fullUrl);
//           setCurrentText(activeSegment.text);
//         }
//       } else {
//         setCurrentIslUrl("");
//         setCurrentText("");
//       }
//     }


//   };

//   useEffect(() => {
//     if (isPlaying) { islVideoRef.current?.play().catch(() => { }); }
//     else { islVideoRef.current?.pause(); }
//   }, [currentIslUrl, isPlaying]);

//   const togglePlay = () => {
//     const vid = uploadedVideoRef.current;
//     if (!vid) return;
//     vid.paused ? vid.play() : vid.pause();
//     setIsPlaying(!vid.paused);
//   };

//   const toggleMute = () => {
//     if (uploadedVideoRef.current) {
//       uploadedVideoRef.current.muted = !isMuted;
//       setIsMuted(!isMuted);
//     }
//   };

//   const handleRedescribe = async () => {
//     if (!userSession?.access_token) {
//       Swal.fire({
//         icon: "warning",
//         title: "Session Expired",
//         text: "Please log in again.",
//       });
//       return;
//     }
//     setIsRedescribing(true);
//     setProgress(0);
//     try {
//       const requestData = {
//         video_id: id,
//         model,
//       };

//       console.log("Redescribe request:", requestData);
//       const ws = new WebSocket(`wss://ccvai.chalachitravaachana.org/ws/${uniqueid}/${id}`);
//       ws.onopen = () => {
//         console.log("WebSocket connected");
//       };

//       ws.onmessage = (event) => {
//         try {
//           const data = JSON.parse(event.data);
//           console.log("WebSocket message:", data);

//           if (data.progress_percent) {
//             setProgress(data.progress_percent);
//           }
//           if (data.progress_percent == "100" && data.video_url) {
//             const updatedVideoUrl = data.video_url.startsWith("http")
//               ? data.video_url
//               : `https://ccvai.chalachitravaachana.org/${data.video_url}`;

//             MySwal.fire({
//               icon: "success",
//               title: "Video Updated!",
//               text: "Redescription successful. Your new video is ready.",
//               showConfirmButton: false,
//               timer: 2500,
//             });

//             setVideo((prev) => ({
//               ...prev,
//               video_url: updatedVideoUrl,
//             }));

//             setIsRedescribing(false);
//             setProgress(100);
//             ws.close();

//             setTimeout(() => {
//               if (videoRef.current) {
//                 videoRef.current.load();
//                 videoRef.current.play().catch((e) => console.warn("Autoplay blocked:", e));
//               }
//             }, 800);
//           }
//         } catch (err) {
//           console.error("WebSocket message error:", err);
//         }
//       };

//       ws.onerror = (error) => {
//         console.error("WebSocket error:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Connection Error",
//           text: "WebSocket connection failed.",
//         });
//         setIsRedescribing(false);
//       };

//       ws.onclose = () => console.log("WebSocket closed");
//       console.log("requestData", requestData)
//       const response = await api.post("https://ccvai.chalachitravaachana.org/redescribe-isl-file", requestData, {
//         headers: {
//           Authorization: `Bearer ${userSession.access_token}`
//         },
//         withCredentials: true,
//       });

//       console.log("Redescribe response:", response.data);
//       if (response.data.status !== "success") {
//         Swal.fire({
//           icon: "warning",
//           title: "Failed",
//           text: response.data.message || "Could not redescribe video.",
//         });
//         setIsRedescribing(false);
//         ws.close();
//       }
//     } catch (error) {
//       console.error("Error redescribing video:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Server Error",
//         text: "Could not redescribe video.",
//       });
//       setIsRedescribing(false);
//     }
//   };



//   return (
//     <div className="isl-app-wrapper">
//       <style>{`
//         html, body { height: 100%; margin: 0; overflow: hidden; background: #ffffff; }
//         .isl-app-wrapper {
//         //  background: #ffffff; 
//             background: #E5E7EB;
//          height: 100vh; 
//          display: flex; 
//          flex-direction: column; 
//          color: #333; }
//         .workspace { flex: 1; display: flex; flex-direction: column; padding: 15px; overflow: hidden; }
//         .video-layout { display: flex; flex: 1; gap: 15px; min-height: 0; }
//         .card-container { 
//         background:black;
//         border: 1px solid #e0e0e0; 
//         border-radius: 8px; display: flex; 
//         flex-direction: column; overflow: hidden;
//          box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
//         .main-video-area { flex: 2; }
//         .side-avatar-area { flex: 1; }
//         .video-header { background: #fdfdfd; padding: 12px 16px; font-size: 1.1rem; color: #222; border-bottom: 1px solid #eee; font-weight: 700; display: flex; align-items: center; }
//         .media-box { 
//         position: relative; flex: 1; display: flex; align-items: center; justify-content: center; overflow: hidden; }
//         video { max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; cursor: pointer; }
//         .controls-overlay { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.65); padding: 8px 15px; display: flex; align-items: center; gap: 12px; z-index: 10; }
//         .icon-btn { background: none; border: none; color: #fff; font-size: 1.3rem; cursor: pointer; padding: 0; display: flex; align-items: center; }
        
//         /* Interactive Progress Rail */
//         .progress-rail { flex: 1; height: 8px; background: rgba(255,255,255,0.3); border-radius: 4px; cursor: pointer; position: relative; transition: height 0.1s; }
//         .progress-rail:hover { height: 10px; }
//         .progress-fill { height: 100%; background: #B01047; border-radius: 4px; pointer-events: none; }
        
// .custom-maroon-btn {
//   background-color: #B01047 !important;
//   border: none !important;
//   color: #fff !important;
// }

// .custom-maroon-btn:hover {
//   background-color: #8c0d3a !important;
// }

//         .timestamp { font-family: monospace; font-size: 0.8rem; color: #fff; min-width: 90px; }
//        /* .action-bar { height: 60px; background: #ffffff; border-top: 1px solid #eee; padding: 0 20px; display: flex; align-items: center; justify-content: space-between; }*/
//        .action-bar { 
//           min-height: 70px; 
//           // background: #ffffff; 
//               background: #E5E7EB;
//           border-top: 1px solid #eee; 
//           padding: 10px 20px; 
//           display: flex; 
//           align-items: center; 
//         }
       
//        @media (max-width: 576px) {
//           .workspace { overflow-y: auto; flex: none; height: auto; }
//           .video-layout { flex: none; }
//           .card-container { height: 350px; }
//           .action-bar { height: auto; padding: 15px; }
//           .action-bar .d-flex { flex-direction: column; align-items: flex-start !important; width: 100%; }
//           .model-select { width: 100%; }
//           .action-bar button { width: 100%; justify-content: center; }
//           html, body { overflow: auto; }
//           .isl-app-wrapper { height: auto; min-height: 100vh; }
//         }
//        .model-select { background: #fff; color: #333; border: 1px solid #ddd; padding: 5px 10px; border-radius: 5px; font-size: 0.8rem; width: 200px; outline: none; }
//         @media (max-width: 991px) {
//           .video-layout { flex-direction: column; overflow-y: auto; }
//           .card-container { flex: none; height: 40vh; margin-bottom: 10px; }
//           html, body { overflow: auto; }
//           .isl-app-wrapper { height: auto; }
//         }
//       `}</style>

//       <NavbarComp1 />

//       <div className="workspace">
//         <div className="video-layout">
//           <div className="card-container main-video-area">
//             <div className="video-header">
//               <i className="bi bi-play-fill me-1" style={{ color: '#B01047' }}></i>
//               {video?.name || "Original Video"}
//             </div>

//             <div className="media-box">
//               <video
//                 ref={uploadedVideoRef}
//                 src={video?.video_url ? `https://ccvai.chalachitravaachana.org${video.video_url}` : ""}
//                 onTimeUpdate={onTimeUpdate}
//                 onClick={togglePlay}
//                 playsInline
//               />
//               <div className="controls-overlay">
//                 <button className="icon-btn" onClick={togglePlay}>
//                   {isPlaying ? <i className="bi bi-pause-fill"></i> : <i className="bi bi-play-fill"></i>}
//                 </button>
//                 <div className="timestamp">{timeText}</div>

//                 <div
//                   className="progress-rail"
//                   ref={progressRailRef}
//                   onClick={handleProgressClick}
//                 >
//                   <div className="progress-fill" style={{ width: `${progressBar}%` }}></div>
//                 </div>

//                 <button className="icon-btn" onClick={toggleMute}>
//                   {isMuted ? <i className="bi bi-volume-mute-fill"></i> : <i className="bi bi-volume-up-fill"></i>}
//                 </button>
//               </div>
//             </div>
//           </div>


//           {/* Avatar Section */}
//           <div className="card-container side-avatar-area">
//             <div className="video-header">
//               <i className="bi bi-play-fill me-1" style={{ color: '#B01047' }}></i> ISL Translator
//             </div>
//             <div className="media-box" style={{ backgroundColor: 'white' }}>
//               {currentIslUrl ? (
//                 <>

//                   <video
//                     key={currentIslUrl}
//                     ref={islVideoRef}
//                     src={currentIslUrl}
//                     autoPlay
//                     muted
//                     loop

//                   />


//                   <div style={{
//                     position: 'absolute',
//                     bottom: '0',
//                     width: '100%',
//                     minHeight: '70px',
//                     padding: '12px 16px',
//                     background: 'rgb(255 255 255 / 25%)',

//                     color: '#8c0d3a',

//                     fontSize: '18px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     textAlign: 'center'
//                   }}>
//                     {currentText}
//                   </div>
//                 </>
//               ) : (
//                 <div className="d-flex flex-column align-items-center justify-content-center">

//                   {isModelLoading ? (
//                     <img
//                       src={loadingImg}
//                       alt="Loading"
//                       style={{
//                         width: "120px",
//                         height: "120px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   ) : selectedModelObj?.db_value === "amrita_m1" ? (
//                     <img
//                       src={isllivetranscriptImg}
//                       alt="Amrita Avatar"
//                       style={{
//                         maxWidth: "80%",
//                         height: "auto",
//                         marginBottom: "10px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   ) : (
//                     <video
//                       src={islCDACImg}
//                       autoPlay
//                       loop
//                       muted
//                       playsInline
//                       style={{
//                         maxWidth: "90%",
//                         height: "auto",
//                         marginBottom: "10px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   )}
//                 </div>

//               )}
//             </div>
//           </div>
//         </div>
//       </div>


//       <div className="action-bar">
//         <div className="d-flex align-items-center flex-wrap gap-3">
//           <div className="d-flex align-items-center gap-2">
//             <span
//               className="fw-bold"
//               style={{ fontSize: '1rem', color: 'black', whiteSpace: 'nowrap' }}
//             >
//               NARRATOR:
//             </span>

//             <select
//               className="model-select"
//               value={model}
//               onChange={(e) => setModel(e.target.value)}
//               style={{ fontSize: '1rem', padding: '6px 12px' }}
//             >
//               {signModelChoices.map((item) => (
//                 <option key={item.key} value={item.key}>
//                   {item.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <Button
//             style={isRedescribing ? styles.maroonBtnDisabled : styles.maroonBtn}
//             onClick={handleRedescribe}
//             disabled={isRedescribing}
//             className="d-flex align-items-center custom-maroon-btn "
//           >
//             {isRedescribing ? (
//               `Processing ${progress}%`
//             ) : (
//               <>
//                 Regenerate ISL

//               </>
//             )}
//           </Button>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default ISLVideoPage;




